module.exports = __webpack_public_path__ + "static/therooftop_02-9738ce4d9c33f00bbb48fb47209e636d.jpg";